import "./App.css";
import { Game } from "./features/game/Game";

function App() {
  return (
    <div className="App">
      <Game />
    </div>
  );
}

export default App;
